{
    "branch": "refs/heads/releases/utrecht-11-09-2026",
    "version": "1.0.4583"
}